/**
 * ScrollBehavior - Manages scroll-based show/hide logic
 *
 * Provides a state machine for determining when to show/hide
 * elements based on scroll position and direction
 */
export class ScrollBehavior {
  constructor(options = {}) {
    this.threshold = options.threshold || 50;
    this.delta = options.delta || 5;
  }

  /**
   * Determine action based on scroll position and direction
   * @param {number} currentScroll - Current scroll Y position
   * @param {number} lastScroll - Previous scroll Y position
   * @param {number} threshold - Optional custom threshold (uses instance default if not provided)
   * @returns {'show' | 'hide' | 'none'}
   */
  getAction(currentScroll, lastScroll, threshold = null) {
    const effectiveThreshold = threshold !== null ? threshold : this.threshold;
    const scrollDifference = currentScroll - lastScroll;

    // Show when at very top
    if (currentScroll === 0) {
      return 'show';
    }

    // Show when scrolling up and within threshold
    if (scrollDifference < -this.delta && currentScroll <= effectiveThreshold) {
      return 'show';
    }

    // Hide when scrolling down past threshold
    if (scrollDifference > this.delta && currentScroll > effectiveThreshold) {
      return 'hide';
    }

    return 'none';
  }

  /**
   * Simple check if element should be visible based on scroll position
   * @param {number} scrollY - Current scroll position
   * @returns {boolean}
   */
  shouldBeVisible(scrollY) {
    return scrollY <= this.threshold;
  }
}
